module.exports = __webpack_public_path__ + "static/img/link.1260588.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/link.svg
// module id = avI/
// module chunks = 2